// extracted by mini-css-extract-plugin
module.exports = {"image":"about-block_image__cie6f","grid":"about-block_grid__T1bgC","lead":"about-block_lead___9PKQ"};